import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { GroupResult } from '@progress/kendo-data-query';
import { PagerModule } from '@progress/kendo-angular-pager';

export class PageChangeEventExtended<T> implements PageChangeEvent {
  totalCount: number;
  skip: number;
  take: number; // pageSize
  group: GroupResult;
  data: T[];
  checked: boolean;
}

// Signal input()/output() are intentionally NOT used here: this pager is mounted
// by 7 consumers' JIT specs, where a signal input binding raises NG0303 (pure JIT
// has no decorator to reflect; Bug 31913 / PR 3314). Decorators stay; the OnPush
// win still lands because primitive @Input changes mark the component for check.
@Component({
  selector: 'ups-grid-grouping-pager',
  imports: [PagerModule],
  templateUrl: './grid-grouping-pager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridGroupingPagerComponent {
  @Input() expanded: boolean;
  @Input() isLastGroup: boolean;
  @Input() isCountToShowPaging: boolean;

  @Input() pageSize: number;
  @Input() skip: number;
  @Input() total: number;

  @Input() addMargin = false;

  @Input() responsive = true;

  @Output() pageChange = new EventEmitter<PageChangeEvent>();
}
